import { schema } from 'normalizr';

const itemSchema = new schema.Entity('items', {}, { idAttribute: 'id' });
const itemsSchema = new schema.Array(itemSchema);
itemSchema.define({ items: itemsSchema });
const SLayoutItemsSchema = new schema.Array(itemSchema);

export { SLayoutItemsSchema };
